module.exports = __webpack_public_path__ + "media/images/icons/facilities/wifi-7a4205ae4c031d3b4ab9f5cff93b2ef4.svg";